import React from 'react';
import MockupShell from './MockupShell';

const BALANCES = [
  { name: 'Lead Credits',     value: 85,  sub: 'Use for Lead Capture campaigns' },
  { name: 'Mailer Credits',   value: 24,  sub: 'Use in Safe List Mailer' },
  { name: 'Rotator Credits',  value: 150, sub: 'High-traffic routing slots' },
  { name: 'Ad Credits',       value: 12,  sub: 'Spend on Marketing Library ads' },
  { name: 'Training Credits', value: 3,   sub: 'Unlock advanced modules' },
];

const LEDGER = [
  { date: '2026-02-21 10:14', type: 'Lead Credits',     dir: 'in',  amt: 10,  reason: 'Tier upgrade bonus (ROOKIE)' },
  { date: '2026-02-21 09:58', type: 'Mailer Credits',   dir: 'in',  amt: 5,   reason: 'Weekly refresh' },
  { date: '2026-02-20 18:32', type: 'Lead Credits',     dir: 'out', amt: 3,   reason: 'Lead Capture · webinar opt-in' },
  { date: '2026-02-20 12:11', type: 'Rotator Credits',  dir: 'out', amt: 15,  reason: 'Active rotator slot · main-split' },
  { date: '2026-02-19 16:45', type: 'Ad Credits',       dir: 'out', amt: 2,   reason: 'Marketing Library banner placement' },
  { date: '2026-02-19 11:02', type: 'Training Credits', dir: 'in',  amt: 1,   reason: 'Completed Module 3' },
];

export default function CreditWallet() {
  return (
    <MockupShell
      title="Credit Wallet"
      subtitle="Five-type unified credit ledger. Every grant, spend, and adjustment is logged."
      dataTestId="mockup-credit-wallet"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>Credits are not money.</strong> They are platform usage tokens you earn through
        activity and unlock through tier upgrades. They have no cash value, cannot be cashed out,
        and are not held custodially. All cash flow on BBC Quick List happens member-to-member on
        TRON TRC-20 via NowPayments.
      </div>

      <div className="mk-grid mk-grid--4" style={{ marginBottom: 18 }}>
        {BALANCES.slice(0, 4).map((b) => (
          <div key={b.name} className="mk-card">
            <div className="mk-stat">
              <span className="mk-stat-label">{b.name}</span>
              <span className="mk-stat-value">{b.value}</span>
              <span className="mk-stat-sub">{b.sub}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mk-grid mk-grid--4" style={{ marginBottom: 22 }}>
        <div className="mk-card">
          <div className="mk-stat">
            <span className="mk-stat-label">{BALANCES[4].name}</span>
            <span className="mk-stat-value">{BALANCES[4].value}</span>
            <span className="mk-stat-sub">{BALANCES[4].sub}</span>
          </div>
        </div>
        <div className="mk-card" style={{ gridColumn: 'span 3', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <div className="mk-stat-label" style={{ marginBottom: 4 }}>Total credits (all types)</div>
            <div style={{ fontSize: 28, fontWeight: 800 }}>274</div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="mk-btn mk-btn--gold-outline">Earn more (open tasks)</button>
            <button className="mk-btn mk-btn--ghost">Tier rewards</button>
          </div>
        </div>
      </div>

      <h3 style={{ margin: '8px 0 12px' }}>Recent ledger activity</h3>
      <div className="mk-card" style={{ padding: 0, overflowX: 'auto' }}>
        <table className="mk-table" style={{ minWidth: 600 }}>
          <thead>
            <tr>
              <th>When</th><th>Credit type</th><th>Direction</th><th>Amount</th><th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {LEDGER.map((row, i) => (
              <tr key={i} data-testid={`ledger-row-${i}`}>
                <td style={{ color: 'var(--mk-muted)', whiteSpace: 'nowrap' }}>{row.date}</td>
                <td>{row.type}</td>
                <td>
                  {row.dir === 'in'
                    ? <span className="mk-badge mk-badge--success">+ Grant</span>
                    : <span className="mk-badge mk-badge--amber">− Spend</span>}
                </td>
                <td style={{ fontWeight: 700, color: row.dir === 'in' ? 'var(--mk-success)' : 'var(--mk-amber)' }}>
                  {row.dir === 'in' ? '+' : '−'}{row.amt}
                </td>
                <td style={{ color: 'var(--mk-muted)' }}>{row.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p style={{ marginTop: 10, fontSize: 11, color: 'var(--mk-dim)' }}>
        Showing 6 of 42 entries · <a href="#" style={{ color: 'var(--mk-gold)' }}>Export CSV</a> · <a href="#" style={{ color: 'var(--mk-gold)' }}>View full ledger</a>
      </p>
    </MockupShell>
  );
}
